import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { DocumentType } from 'document/model/document.type';
import { ISection } from 'phase/section/section';

import { DocumentI18n, IDocumentI18n } from './document-i18n';

export interface IDocument extends IEntity {
	readonly ownerId: string;
	readonly type: DocumentType;
	readonly phaseId: string;
	readonly moduleId: string;
	readonly sectionId: string;
	readonly cssIconClass: string;
	readonly localizations: ReadonlyArray<IDocumentI18n>;
	readonly localization$: Observable<IDocumentI18n>;

	readonly section$: Observable<ISection>;
}

export class Document extends Entity implements IDocument {
	private _ownerId: string;
	private _type: DocumentType;
	private _phaseId: string;
	private _moduleId: string;
	private _sectionId: string;
	private _cssIconClass: string;
	private _localizations: DocumentI18n[];
	private _localization$: Observable<DocumentI18n>;

	private _section$: Observable<ISection>;

	constructor(
		id: string,
		ownerId: string,
		type: DocumentType,
		phaseId: string,
		moduleId: string,
		sectionId: string,
		updateTimestamp: number,
		creationTimestamp: number,
		localizations: DocumentI18n[],
		localization$: Observable<DocumentI18n> = of(null),
		section$: Observable<ISection> = of(null)
	) {
		super(id, creationTimestamp, updateTimestamp);
		this._type = type;
		this._ownerId = ownerId;
		this._phaseId = phaseId;
		this._moduleId = moduleId;
		this._sectionId = sectionId;
		this._localizations = localizations;
		this._localization$ = localization$;
		this._section$ = section$;

		switch (type) {
			case 'IMAGE':
				this._cssIconClass = 'fak fa-str-image-landscape';
				break;
			case 'MODULE':
				this._cssIconClass = 'fak fa-str-file-user';
				break;
			case 'ANSWERS':
				this._cssIconClass = 'fak fa-str-file-cube';
				break;
			case 'ANSWER':
				this._cssIconClass = 'fak fa-str-file-cube';
				break;
			case 'DOCUMENT':
				this._cssIconClass = 'fak fa-str-file-text';
				break;
			case 'MEETING_EXPORT':
				this._cssIconClass = 'far fa-file-export';
				break;
			default:
				this._cssIconClass = 'fak fa-str-file';
				break;
		}
	}

	public get type(): DocumentType {
		return this._type;
	}

	public get ownerId(): string {
		return this._ownerId;
	}

	public get phaseId(): string {
		return this._phaseId;
	}

	public get moduleId(): string {
		return this._moduleId;
	}

	public get sectionId(): string {
		return this._sectionId;
	}

	public get cssIconClass(): string {
		return this._cssIconClass;
	}

	public get localizations(): DocumentI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<DocumentI18n> {
		return this._localization$;
	}

	public get section$(): Observable<ISection> {
		return this._section$;
	}
}
